import React from "react";

import GoalDetailsProps from "@app/scene/dashboard/types/GoalDetailsProps";

import GoalDetailsFormComponent from "../common/GoalDetailsFormComponent";

interface Props extends GoalDetailsProps {}

const GoalDetailsComponent: React.FC<Props> = (props) => {
  return <GoalDetailsFormComponent currencyType {...props} />;
};

export default GoalDetailsComponent;
